// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__X96it","tileImg":"Tile_tileImg__iVJVX","tileTitle":"Tile_tileTitle__gPwXq","tileText":"Tile_tileText__Sk2ko","shopLink":"Tile_shopLink__QuOPg"};